import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

export const actionButtonsGrid = style({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: vars.space.xs,
});

export const buttonItem = style({
  gridColumnStart: "auto",
  selectors: {
    "&:nth-child(3):last-child": {
      gridColumnStart: "span 2",
    },
  },
});
